// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_pg-8";
export var editMode = "_pg-3";
export var headerRow = "_pg-a";
export var headerTitle = "_pg-b";
export var product = "_pg-1";
export var productDetails = "_pg-5";
export var productDivider = "_pg-7";
export var productImage = "_pg-2";
export var productInfo = "_pg-4";
export var productTitle = "_pg-6";
export var strikethrough = "_pg-9";
export var upsellProductsCard = "_pg-0";